import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import fr from "./fr.json";

const savedLang = typeof localStorage !== "undefined" ? localStorage.getItem("sm_lang") : null;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: savedLang === "fr" || savedLang === "en" ? savedLang : "fr",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
